import { ERROR_MESSAGE } from 'constants/errors';
import { useHomeList } from './HomeList/useHomeList';
import { useHomeShow } from './HomeShow/useHomeShow';
import { useNotification } from 'hooks/useNotification';
import { useLoadingStore } from 'store/loadingStore';

export const useSetupAppHome = () => {
  const { uploadHomeShow } = useHomeShow();
  const { uploadHomeList } = useHomeList();
  const { openSuccessNotification, openErrorNotification } = useNotification();

  const savingHomeApp = useLoadingStore(state => state.savingHomeApp);
  const setSavingHomeApp = useLoadingStore(state => state.setSavingHomeApp);

  const saveAppHome = async () => {
    try {
      setSavingHomeApp(true);

      await Promise.all([uploadHomeShow, uploadHomeList].map(r => r()));

      openSuccessNotification({
        message: 'Home do App atualizada',
      });
    } catch (error) {
      const errorTextMessage =
        error?.response?.data?.message ||
        error?.message ||
        ERROR_MESSAGE.TRY_LATER;
      openErrorNotification({
        title: errorTextMessage,
      });
    } finally {
      setSavingHomeApp(false);
    }
  };

  const saveAppHomeShow = async () => {
    try {
      setSavingHomeApp(true);

      await uploadHomeShow();

      openSuccessNotification({
        message: 'Home Show atualizada',
      });
    } catch (error) {
      const errorTextMessage =
        error?.response?.data?.message ||
        error?.message ||
        ERROR_MESSAGE.TRY_LATER;
      openErrorNotification({
        title: `Home Show: ${errorTextMessage}`,
      });
    } finally {
      setSavingHomeApp(false);
    }
  };

  const saveAppHomeList = async () => {
    try {
      setSavingHomeApp(true);

      await uploadHomeList();

      openSuccessNotification({
        message: 'Home List atualizada',
      });
    } catch (error) {
      const errorTextMessage =
        error?.response?.data?.message ||
        error?.message ||
        ERROR_MESSAGE.TRY_LATER;
      openErrorNotification({
        title: `Home List: ${errorTextMessage}`,
      });
    } finally {
      setSavingHomeApp(false);
    }
  };

  return {
    saveAppHome,
    savingHomeApp,
    saveAppHomeShow,
    saveAppHomeList,
    setSavingHomeApp,
  };
};
